import { render, staticRenderFns } from "./SlideSearchPopup.vue?vue&type=template&id=b20ee9a8&scoped=true"
import script from "./SlideSearchPopup.vue?vue&type=script&lang=js"
export * from "./SlideSearchPopup.vue?vue&type=script&lang=js"
import style0 from "./SlideSearchPopup.vue?vue&type=style&index=0&id=b20ee9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20ee9a8",
  null
  
)

export default component.exports